/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useEffect, useRef } from "react";
import { cn } from "tailwind-variants";
import { useI18n } from "intl/useI18n";
import { isMediumDeviceAndUp } from "common/utils/browser";
import CommonModal from "common/vue/components/CommonModal.react.vue";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { useDtfStore } from "../../store";
import Section from "../components/Section.vue";
import RedrawNotes from "../../RedrawNotes.vue";
import RedrawInformation from "../../Modals/RedrawInformation.vue";
import DesignServicesSubscribe from "./DesignServicesSubscribe.vue";
import "./DesignServices.scss";

export default function DesignServices({
  artwork,
  // @ts-expect-error TS(6133): 'paidExpertEditAddonEnabled' is declared but its v... Remove this comment to see the full error message
  paidExpertEditAddonEnabled,
  index,
  isMultiUpload
}: any) {
  const store = useDtfStore();
  // @ts-expect-error TS(2339): Property 'numberFormatter' does not exist on type ... Remove this comment to see the full error message
  const { numberFormatter, n } = useI18n();

  const [isExpertEditAddonChecked, setIsExpertEditAddonChecked] = useState(
    artwork.hasExpertEditAddon || false
  );
  const [isRedrawModalOpen, setIsRedrawModalOpen] = useState(false);
  const [isMobile] = useState(!isMediumDeviceAndUp());
  const redrawModal = useRef(null);

  function isStandardDTFProduct() {
    // @ts-expect-error TS(4111): Property 'isStandardDTFProduct' comes from an inde... Remove this comment to see the full error message
    return store.isStandardDTFProduct;
  }

  function showRedrawUI() {
    if (isStandardDTFProduct()) {
      return true;
    }
    return isExpertEditAddonChecked;
  }

  function isLoading() {
    const price = artwork.pricing?.expertEditAddonTierPrice;
    return price === undefined || price === null;
  }

  function isFree() {
    return !isLoading() && artwork.pricing.expertEditAddonTierPrice <= 0;
  }

  function expertEditAddonTierPrice() {
    if (isLoading()) {
      return "";
    }
    if (isFree()) {
      return "FREE";
    }
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 3.
    return n(artwork.pricing.expertEditAddonTierPrice, "currency", numberFormatter);
  }

  useEffect(() => {
    setIsExpertEditAddonChecked(artwork.hasExpertEditAddon || false);
  }, [artwork.hasExpertEditAddon]);

  function openRedrawModal() {
    setIsRedrawModalOpen(true);
  }

  function closeRedrawModal() {
    if (redrawModal.current) {
      // @ts-expect-error TS(2339): Property 'close' does not exist on type 'never'.
      redrawModal.current.close();
    }
    setIsRedrawModalOpen(false);
  }

  function onExpertEditAddonToggle(checked: any) {
    if (artwork.isSimulated) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.setSimulation({
        hasExpertEditAddon: checked
      });
    } else {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.updateArtworkValuesById({
        id: artwork.id,
        hasExpertEditAddon: checked,
        enhancementNote: ""
      });
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.getArtworksPricing();
    // @ts-expect-error TS(4111): Property 'showDesignServicesDeliveryBuffer' comes ... Remove this comment to see the full error message
    if (store.showDesignServicesDeliveryBuffer) {
      // Trigger delivery estimates if:
      // - Unchecking (to reset with false flag)
      // - Checking AND notes have content (to enable with true flag)
      if (!checked || (checked && artwork.enhancementNote?.trim())) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        store.updatePdpDates();
      }
    }
    submitDtfEvent("expert_edit_addon_toggled", {
      artwork_id: artwork.id,
      // @ts-expect-error TS(4111): Property 'productId' comes from an index signature... Remove this comment to see the full error message
      product_id: store.productId,
      enabled: checked,
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      business_line: store.businessLine,
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      catalog_number: store.catalogNumber,
      active_config_section: artwork.enhancementTier
    });
  }

  return (
    <>
      <Section className="design-services scope-fb032041" data-testid="design-services">
        <div className="design-services__header scope-fb032041">
          {!isStandardDTFProduct() ? (
            <label
              className="design-services__checkbox scope-fb032041"
              id="jiffy-design-services-addon-label"
              data-testid="design-services-checkbox"
            >
              <input
                className="design-services__input scope-fb032041 sr-only"
                checked={isExpertEditAddonChecked}
                onChange={e => {
                  const { checked } = e.target;
                  setIsExpertEditAddonChecked(checked);
                  onExpertEditAddonToggle(checked);
                }}
                type="checkbox"
                data-testid="print-perfect-design-services-checkbox"
              />
              <div className="design-services__checkbox-box scope-fb032041">
                {isExpertEditAddonChecked ? (
                  <UseSvg
                    className="design-services__checkbox-icon scope-fb032041"
                    icon="check"
                    data-testid="design-services-checkbox-icon"
                  />
                ) : null}
              </div>
              <div className="design-services__label scope-fb032041">
                <div className="design-services__label-text scope-fb032041">
                  {" "}
                  Jiffy Design Services{" "}
                  <span className="design-services__badge scope-fb032041">Add-On</span>
                </div>
                <div className="design-services__help scope-fb032041">
                  Use our professional designers to edit your image
                </div>
              </div>
            </label>
          ) : null}
          {!isStandardDTFProduct() ? (
            <div className="design-services__actions scope-fb032041">
              <div
                className={cn(
                  "design-services__price scope-fb032041",
                  isFree() && "design-services__price--free"
                )}
              >
                {expertEditAddonTierPrice()}
              </div>
              <button
                className="design-services__learn-more scope-fb032041"
                type="button"
                onClick={openRedrawModal}
                data-testid="design-services-learn-more"
              >
                {" "}
                Learn More{" "}
              </button>
            </div>
          ) : null}
        </div>
        {showRedrawUI() ? (
          <div
            className="design-services__notes js-print-perfect-redraw-notes-addon scope-fb032041"
            data-id={artwork.id}
          >
            <RedrawNotes
              index={index}
              enhancementNote={artwork.enhancementNote}
              {...(isStandardDTFProduct() ? { onLearnMore: openRedrawModal } : {})}
            />
          </div>
        ) : null}
        {!isMultiUpload ? (
          <DesignServicesSubscribe
            className="scope-fb032041"
            requestSatisfied={artwork.pinningSessionState === "approved"}
            data-testid="design-services-subscribe"
          />
        ) : null}
      </Section>
      {}
      {isRedrawModalOpen ? (
        <CommonModal
          className="scope-fb032041"
          ref={redrawModal}
          compact={true}
          hideCloseButton={false}
          bottomAligned={isMobile}
          onClose={closeRedrawModal}
          data-testid="common-modal"
        >
          <RedrawInformation
            className="scope-fb032041"
            isMobile={isMobile}
            onClose={closeRedrawModal}
            data-testid="redraw-information"
          />
        </CommonModal>
      ) : null}
    </>
  );
}
